import { render, staticRenderFns } from "./add-custom-cloaking-domain-dialog.vue?vue&type=template&id=707a65b8&scoped=true&"
import script from "./add-custom-cloaking-domain-dialog.vue?vue&type=script&lang=ts&"
export * from "./add-custom-cloaking-domain-dialog.vue?vue&type=script&lang=ts&"
import style0 from "./add-custom-cloaking-domain-dialog.vue?vue&type=style&index=0&id=707a65b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "707a65b8",
  null
  
)

export default component.exports